var map = {
	"./num0.png": "12b9",
	"./num1.png": "65a7",
	"./num2.png": "237c",
	"./num3.png": "b738",
	"./num4.png": "d24e",
	"./num5.png": "9899",
	"./num6.png": "a358",
	"./num7.png": "ece0",
	"./num8.png": "7e1a",
	"./num9.png": "064a",
	"./numx.png": "5515"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4096";